export async function getList({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.proposals.index(payload);
  if (!errResponse && responseData.success) {
    commit('setList', responseData.data.proposals);
    commit('setListTags', responseData.data.tags);
    return responseData.data.proposals
  }

  return [];
}

export async function createProposal({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.proposals.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updateProposal({commit}, {payload, id}) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.proposals.update(id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findProposalById({commit}, payload) {
  return await this.$adminRepositories.proposals.show(payload);
}

export async function deleteProposalById({dispatch}, payload) {
  const response = await this.$adminRepositories.proposals.delete(payload.id);
  await dispatch('getList');
  return response;
}
